import { isMobile } from 'swag-client-common/utils/ui.utils';
const mobileView = isMobile();
export const anchorOrigin = {
  horizontal: mobileView && 'middle' || 'left',
  vertical: mobileView && 'bottom' || 'top'
};
export const targetOrigin = {
  horizontal: mobileView && 'middle' || 'right',
  vertical: mobileView && 'top' || 'top'
};